import React from 'react';

import { Icon } from '@chakra-ui/react';

export const CloudIdentityIcon = props => (
  <Icon viewBox="0 0 721 721" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-540 -92)">
      <g>
        <g>
          <g>
            <g>
              <path d="M1141 273C1157.57 273 1171 286.431 1171 303L1171 603C1171 619.569 1157.57 633 1141 633L661 633C644.431 633 631 619.569 631 603L631 303C631 286.431 644.431 273 661 273Z" stroke="currentColor" strokeWidth="60" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeOpacity="1" fill="none" fillRule="nonzero" />
              <path d="M961.06 407.13 1081.06 407.13" stroke="currentColor" strokeWidth="30" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeOpacity="1" fill="none" fillRule="nonzero" />
              <path d="M961.06 498.36 1081.06 498.36" stroke="currentColor" strokeWidth="30" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeOpacity="1" fill="none" fillRule="nonzero" />
              <path d="M735.76 377.7 885.97 377.7 885.97 527.91 735.76 527.91Z" stroke="currentColor" strokeWidth="30" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeOpacity="1" fill="none" fillRule="nonzero" />
              <path d="M781.09 423.27 841.51 423.27 841.51 483 781.09 483Z" stroke="currentColor" strokeWidth="30" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeOpacity="1" fill="none" fillRule="nonzero" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
